import "./ChatText.css"

export default function ChatText(props){
    return(
        <div className="ChatText">
            {props.children}
        </div>
    )
}